import { FollowableUser } from 'js/social/shared/types';

import { Tag } from 'js/social/shared/types';

import { useCallback, useState } from 'react';

type ItemDraft = {
  content: string;
  tags: Tag[];
};

function loadDraft(
  id: string,
  getUserData: (id: number) => FollowableUser,
): ItemDraft {
  const draft = window.sessionStorage.getItem(id);
  if (draft != null) {
    try {
      const parsedDraft = JSON.parse(draft);
      // Attempt to get the user data for each tagged user. If it fails, just clear the draft.
      parsedDraft.tags.forEach((tag: Tag) => {
        getUserData(tag.tagId);
      });
      return parsedDraft;
    } catch {
      window.sessionStorage.removeItem(id);
    }
  }
  return { content: '', tags: [] };
}

export const useDraft = (
  id: string,
  initialContent: string | undefined,
  initialTags: Tag[] | undefined,
  getUserData: (id: number) => FollowableUser,
): {
  draftContent: string;
  draftTags: Tag[];
  saveDraft: (content: string, tags: Tag[]) => void;
  clearDraft: () => void;
} => {
  // Load draft
  const [draft] = useState<ItemDraft>(() =>
    initialContent === undefined && initialTags === undefined
      ? loadDraft(id, getUserData)
      : { content: initialContent || '', tags: initialTags || [] },
  );

  const saveDraft = useCallback(
    (content: string, tags: Tag[]) => {
      const draft = { content, tags };
      window.sessionStorage.setItem(id, JSON.stringify(draft));
    },
    [id],
  );

  const clearDraft = useCallback(() => {
    window.sessionStorage.removeItem(id);
  }, [id]);

  return {
    draftContent: draft.content,
    draftTags: draft.tags,
    saveDraft,
    clearDraft,
  };
};
